export default __webpack_public_path__ + "static/media/Flames.bb800f76.png";